// React Third Party Library
import { Col, Drawer, Form, Row, Select } from "antd";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

// Services Library
import { REDUX as REDUX_UTIL } from "../../../../services/util";

// Components Library
import { BtnSubmit } from "../../../../components";
import CompanyInformation from "./CompanyInformation";
import ReviseCreditThreshold from "./ReviseCreditThreshold";
import GeneralSetting from "./GeneralSetting";
import LoyaltyInfomation from "./LoyaltyInformation";

const { reduxStoreWrapper } = REDUX_UTIL;

const DrawerCompany = (props) => {
    const { isOpen, setIsOpen, type, form, handleSave, data, readOnly } = props;
    const [newData, setNewData] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);

    const employer = Object.values(useSelector(reduxStoreWrapper("employer.byID"))) || [];
    const employerNoCoid = Object.values(useSelector(reduxStoreWrapper("employer.byNoCOID"))) || [];
    const emprOptions = employerNoCoid.map((emp) => {
      return {
        value: emp.uid,
        label: emp.name
      }
    })

    useEffect(() => {
      if (data && data.listEmployer) {
        const filteredData = (data.listEmployer).map((emplr) => {
          return {
            value: emplr.uid,
            label: emplr.name
          }
        })
        setSelectedItems(filteredData);
      }
      else if (setIsOpen && !data) {
        setSelectedItems([]);
      }
      else {
        setNewData([]);
      }
    }, [isOpen]);

    const handleChange = (selectedValues) => {
      const newSelectedItems = selectedValues.map((uid) => {
        const employerData = employer.find((emp) => emp.uid === uid);
        return {
          value: uid,
          label: employerData ? employerData.name : 'Unknown'
        };
      });
      setSelectedItems(newSelectedItems);
      form.setFieldsValue({
        listEmployer : newSelectedItems
      })
    };

    const ActionButton = (
        <Form.Item style={{ paddingTop: "20px" }}>
          <div>
            <BtnSubmit
              display="inline-block"
              text={type === "Create" ? "Create" : "Save"}
              bgColor="#0E2483"
              color="white"
              padding="9px 18px"
              onClick={() => {
                handleSave();
                setIsOpen(false);
              }}
            />
            {type === "Create" && (
              <BtnSubmit
                display="inline-block"
                text="Create & add Another"
                bgColor="#0E2483"
                color="white"
                padding="9px 15px"
                onClick={() => {
                  form.resetFields();
                }}
              />
            )}
            <BtnSubmit
              display="inline-block"
              text="Cancel"
              bgColor="transparent"
              color="#c8c8c8"
              padding="9px 18px"
              border="1px solid #c8c8c8"
              onClick={() => {
                setIsOpen(false);
                form.resetFields();
              }}
            />
          </div>
        </Form.Item>
      );
    
    // const CustomUpload = ({ label }) => (
    //   <Upload
    //     showUploadList={false}
    //   >
    //     <Form.Item name="projPaper">
    //       <Input
    //         style={{ width: "135%" }}
    //         className="inputForm"
    //         suffix={<ButtonLink>Upload</ButtonLink>}
    //         name="projPaper"
    //       />
    //     </Form.Item>
    //   </Upload>
    // );

    return (
      <>
        <Drawer
            title={type === "Create" ? "Create Company" : (type === "Edit" ? "Edit Company" : "Revise Credit Threshold")}
            open={isOpen}
            onClose={() => setIsOpen(false)}
            width={410}
            closable={false}
            style={{
            textAlign: "center",
            fontSize: "15px",
            }}
            footer={ActionButton}
        >
          <Form form={form} layout="vertical">
              <>
                <CompanyInformation props={{ type, readOnly }} />
                  
                <ReviseCreditThreshold props={{ isOpen, setIsOpen, type, form, handleSave }} />

                <GeneralSetting props={{ isOpen, setIsOpen, type, form, handleSave, data, readOnly }} />
                
                <LoyaltyInfomation props={{ isOpen, setIsOpen, type, form, handleSave }} />

                { type === "Revise" ? (
                  <></>
                ) : (
                  <>
                    <Row>
                      <Col style={{ width: "100%", marginBottom: "10px", marginTop: "10px" }}>
                        <Form.Item>
                          <Row
                            style={{
                              color: "#cacaca",
                              alignItems: "center",
                              fontSize: "15px",
                            }}
                          >
                            <Col
                              span={22}
                              style={{ textAlign: "left", width: "100%" }}
                            >
                              Employer(s) Information
                            </Col>
                          </Row>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col style={{ width: "100%"}}>
                        <label htmlFor="label" className="labelInput">
                          Assign employer(s) ({selectedItems.length})
                        </label>
                        <Form.Item
                          name="listEmployer"
                          >
                          <Row
                            style={{
                              color: "#cacaca",
                              alignItems: "center",
                              fontSize: "15px",
                            }}                            
                          >
                            <Select
                              mode="multiple"
                              size={"large"}
                              placeholder="Please select"
                              onChange={handleChange}
                              value={selectedItems}
                              style={{
                                width: '100%'
                              }}
                              options={emprOptions}
                            />
                          </Row>
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                ) }
            </>
          </Form>
        </Drawer>
      </>
    )
}

export default DrawerCompany